<template>
    <div>
        <e-dialog
                dialog-title="图片上传"
                :center-dialog-visible="uploadFileVisible"
                popup-width="400px"
                :closeBtn="true"
                @submitPopupData="submitPopupData"
                @resetPopupData="handleClose">
            <div class="flex-sc">
                <div>图片上传：</div>
                <eui-upload
                        ref="euiUpload1"
                        key-name="auditorCertificate"
                        :file-list="fileList"
                        :action="uploadPayCenterFile"
                        :private-upload="privateUpload"
                        :headers="headers"
                        :limit="limit"
                        :show-file-list="true"
                        accept=".jpg,.png,.jpeg,.pdf"
                        single
                        text="上传附件"
                        @handleSuccess="userUploadSuccess"
                >
                </eui-upload>
            </div>

        </e-dialog>
    </div>
</template>

<script>
import api from '@/modules/projectA/api/paymentAccount/index';
import eDialog from '@/components/common/e-dialog.vue';
import { epecToken } from '../../../utils/globalData';
export default {
  name: "uploadFileDialog",
  components:{
    eDialog
  },
  props:{
    uploadFileVisible:Boolean,
  },
  data(){
    return{
      fileList:[],
      limit:1,
      uploadPayCenterFile:api.uploadPayCenterFile,
      privateUpload : {
        keyName: 'filePath',
        url: api.getSupplierLicence,
        method: 'get',
      },
      headers:epecToken,
      fileData:{},
    }
  },
  methods:{
    submitPopupData(){
      this.$emit('handleConfirm',this.fileData);
    },
    userUploadSuccess(file) {
      this.fileList = [];
      this.fileData = file.data;
      setTimeout(() => {
        this.getPayCenterFile();
      }, 1000);
    },
    async getPayCenterFile() {
      const res = await api.getPayCenterFile({filePath: this.fileData.url});
      if (res.success) {
        this.fileList.push({name: this.fileData.fileName, url: res.data});
      }
    },
    handleClose(){
      this.$emit('update:uploadFileVisible', false);
    },
  },

}
</script>

<style scoped lang="scss">

</style>